<template>
  <div>
    <v-navigation-drawer
      app
      clipped
      v-model="drawer"
      width="240"
      :color="COLORS.drawer"
      mobile-breakpoint="960"
      :mini-variant="minivariant && !$vuetify.breakpoint.mdAndDown"
      :expand-on-hover="minivariant && !$vuetify.breakpoint.mdAndDown"
      :temporary="false"
      class="suspended-drawer"
      :class="{ 'suspended-drawer--open': $vuetify.breakpoint.mdAndDown && drawer, closing: closing }"
      @mouseenter.native="isHovering = true"
      @mouseleave.native="isHovering = false"
    >
      <div class="drawer-logo-container">
        <div class="drawer-logo" style="cursor: pointer" v-if="showFullLogo" @click="dashboard">
          <img src="../../assets/logos/aprovacaobrasil.png" alt="Logo do sistema" />
        </div>

        <div class="drawer-logo" style="cursor: pointer" v-else @click="dashboard">
          <img src="/favicon.png" alt="Favicon do sistema" />
        </div>

        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          icon
          small
          class="close-drawer-btn"
          @click="requestCloseMobileDrawer"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-btn style="margin-left: 40%; margin-top: 10px" v-if="!!!user" :loading="!!!user" depressed text></v-btn>

      <div class="drawer-menu-scroll custom-scrollbar">
        <v-list nav dense v-for="item in getMenus()" :key="item.title" class="pa-0 drawer-menu-list">
          <v-list-item
            link
            color="primary"
            class="mx-1 menu-item"
            :class="{ 'menu-item--active': isRouteActive(item.to) }"
            :to="item.to"
            v-show="!item.children"
            dense
          >
            <v-list-item-icon class="menu-icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="menu-title">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            color="black"
            class="px-1 menu-group"
            :class="{ 'menu-group--active': isGroupActive(item) }"
            v-show="item.children"
            :value="openGroup === item.title"
            @input="onGroupInput(item.title, $event)"
          >
            <template v-slot:activator>
              <v-list-item class="menu-group-activator pl-0" dense>
                <v-list-item-icon class="menu-icon">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="menu-title">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              color="primary"
              class="menu-child-item"
              :class="{ 'menu-child-item--active': isRouteActive(record.to) }"
              v-for="record in item.children"
              :key="record.title"
              :to="record.to"
              dense
            >
              <v-list-item-icon class="menu-icon menu-icon--child">
                <v-icon small>{{ record.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="menu-title menu-title--child">{{ record.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
      </div>

      <div class="copyright pb-4 pt-3" v-if="isSidebarOpen">
        Copyright &copy; {{ new Date().getFullYear() }} - Aprovação Brasil<br />
        Todos os direitos reservados
      </div>
      <div class="copyright pb-4 pt-3" v-else>
        Copyright <br />
        {{ new Date().getFullYear() }}
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import COLORS from "@/constants/colors.js";

export default {
  data() {
    return {
      drawerMobile: false,
      closing: false,
      openGroup: null,
      isHovering: false,
      isSidebarOpen: true,
      items: [
        {
          title: "Cidades",
          icon: "mdi-city-variant-outline",
          to: "/cidades",
          perfis: ["Master"],
        },
        {
          title: "Usuários",
          icon: "mdi-account-cog-outline",
          to: "/usuarios",
          perfis: ["Master"],
        },
        {
          title: "Respostas",
          icon: "mdi-clipboard-check-outline",
          to: "/respostas-alunos",
          perfis: ["Master"],
        },
        {
          title: "Laudos",
          icon: "mdi-file-document-multiple-outline",
          to: "/Laudos",
          perfis: ["Administrador", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
        },
        {
          title: "Ação/Conteúdo",
          icon: "mdi-notebook-edit-outline",
          to: "/planejamento-acao",
          perfis: [
            "Administrador",
            "Professor",
            "Coordernador Escolar",
            "Diretor",
            "Secretário da Educação",
            "Personalizado1",
          ],
        },
        {
          title: "Lançamento Manual",
          icon: "mdi-pencil-box-outline",
          to: "/manuais",
          perfis: ["Administrador"],
        },
        {
          title: "Cadastros",
          icon: "mdi-folder-account-outline",
          perfis: ["Administrador"],
          children: [
            {
              title: "Alunos",
              icon: "mdi-account-school-outline",
              to: "/alunos",
              perfis: ["Administrador", "Master"],
            },
            {
              title: "Turmas",
              icon: "mdi-account-group-outline",
              to: "/turma",
              perfis: ["Administrador"],
            },
            {
              title: "Escolas",
              icon: "mdi-school-outline",
              to: "/Escolas",
              perfis: ["Administrador"],
            },
            {
              title: "Avaliações",
              icon: "mdi-calendar-check",
              to: "/avaliacao",
              perfis: ["Administrador"],
            },
            {
              title: "Cadernos",
              icon: "mdi-book-open-page-variant-outline",
              to: "/cadernos",
              perfis: ["Administrador"],
            },
          ],
        },
        {
          title: "Proficiência",
          icon: "mdi-chart-bell-curve-cumulative",
          perfis: [
            "Administrador",
            "Professor",
            "Coordernador Escolar",
            "Diretor",
            "Secretário da Educação",
            "Personalizado1",
          ],
          children: [
            {
              title: "Aluno",
              icon: "mdi-account-school-outline",
              to: "/relatorios/aluno",
              perfis: [
                "Administrador",
                "Professor",
                "Coordernador Escolar",
                "Diretor",
                "Secretário da Educação",
                "Personalizado1",
              ],
            },
            {
              title: "Proficiência do Aluno",
              icon: "mdi-account-star",
              to: "/relatorios/proficiencia-do-aluno-v2",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Proficiência da Turma",
              icon: "mdi-account-group",
              to: "/relatorios/proficiencia-da-turma-v2",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Proficiência da Escola",
              icon: "mdi-school",
              to: "/relatorios/proficiencia-da-escola-v2",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Proficiência da Rede",
              icon: "mdi-graph",
              to: "/relatorios/proficiencia-da-rede-v2",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Proficiência por Questão",
              icon: "mdi-format-list-numbered-rtl",
              to: "/relatorios/proficiencia-por-questao",
              perfis: [
                "Administrador",
                "Professor",
                "Coordernador Escolar",
                "Diretor",
                "Secretário da Educação",
                "Personalizado1",
              ],
            },
            {
              title: "Proficiência por Escola",
              icon: "mdi-chart-line-stacked",
              to: "/relatorios/proficiencia-por-escola",
              perfis: [
                "Administrador",
                "Professor",
                "Coordernador Escolar",
                "Diretor",
                "Secretário da Educação",
                "Personalizado1",
              ],
            },
          ],
        },
        {
          title: "Relatórios",
          icon: "mdi-file-chart-outline",
          perfis: [
            "Administrador",
            "Professor",
            "Coordernador Escolar",
            "Diretor",
            "Secretário da Educação",
            "Personalizado1",
          ],
          children: [
            {
              title: "Comparativo de Escolas",
              icon: "mdi-chart-areaspline",
              to: "/relatorios/comparativo-escolas",
              perfis: [
                "Administrador",
                "Secretário da Educação",
                "Personalizado1",
              ],
            },
            {
              title: "Evolução",
              icon: "mdi-chart-timeline-variant-shimmer",
              to: "/relatorios/evolucao",
              perfis: [
                "Administrador",
                "Professor",
                "Coordernador Escolar",
                "Diretor",
                "Secretário da Educação",
                "Personalizado1",
              ],
            },
            {
              title: "Quantitativo",
              icon: "mdi-chart-box-outline",
              to: "/relatorios/quantitativo",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Desempenho",
              icon: "mdi-chart-bar",
              to: "/relatorios/desempenho",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Desempenho da Turma",
              icon: "mdi-account-group-outline",
              to: "/relatorios/desempenho-turma",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Rendimento",
              icon: "mdi-percent-outline",
              to: "/relatorios/rendimento",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
            {
              title: "Participação",
              icon: "mdi-chart-pie",
              to: "/relatorios/participacao",
              perfis: ["Administrador", "Professor", "Coordernador Escolar", "Diretor", "Secretário da Educação"],
            },
          ],
        },
        {
          title: "Sondagem/Infantil",
          icon: "mdi-baby-face-outline",
          to: "/sondagem-infantil",
          perfis: [
            "Master",
            "Administrador",
            "Coordernador Escolar",
            "Diretor",
            "Secretário da Educação",
            "Personalizado1",
          ],
        },
        {
          title: "Informe TCE",
          icon: "mdi-file-document-outline",
          to: "/quesitos/cadastro",
          perfis: ["Master"],
        },
        {
          title: "Notícias",
          icon: "mdi-newspaper-variant-multiple-outline",
          to: "/noticias",
          perfis: ["Master"],
        },
        {
          title: "Informe TCE",
          icon: "mdi-file-document-outline",
          to: "/quesitos",
          perfis: ["Administrador", "Secretário da Educação"],
        },
        {
          title: "Comunicação",
          icon: "mdi-message-outline",
          to: "/comunicacao",
          perfis: [
            "Master",
            "Administrador",
            "Coordernador Escolar",
            "Diretor",
            "Secretário da Educação",
            "Personalizado1",
          ],
        },
        {
          title: "Juntar Alunos",
          icon: "mdi-account-multiple-plus",
          to: "/juntar-alunos",
          perfis: ["Master", "Administrador"],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "Login/user",
      minivariant: "General/minivariant",
    }),
    COLORS: () => COLORS,
    showFullLogo() {
      // Mostra logo completa se não está em mini-variant
      if (!this.minivariant) return true;
      // Se está em tela pequena, mostra logo se drawer está aberta
      if (this.$vuetify.breakpoint.mdAndDown) {
        return this.drawerMobile;
      }
      // Se está em mini-variant em tela grande, mostra logo quando hovering
      return this.isHovering;
    },
    currentPath() {
      return this.normalizePath(this.$route ? this.$route.path : "");
    },
    ownerInitials() {
      const ownerName = this.user && this.user.owner ? this.user.owner.nome : "";

      if (!ownerName) return "--";

      return ownerName
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((name) => name.charAt(0).toUpperCase())
        .join("");
    },
    drawer: {
      get() {
        if (this.$vuetify.breakpoint.mdAndDown) {
          return this.drawerMobile;
        }
        return true;
      },
      set(value) {
        if (this.$vuetify.breakpoint.mdAndDown) {
          this.drawerMobile = value;
        }
      },
    },
  },
  methods: {
    dashboard() {
      if (this.$router.currentRoute.path != "/") {
        this.$router.push("/");
      }
    },
    onGroupInput(title, val) {
      if (val) {
        this.openGroup = title;
      } else if (this.openGroup === title) {
        this.openGroup = null;
      }
    },
    showMenu(item) {
      return item.perfis.includes(this.user ? this.user.perfil : "");
    },
    normalizePath(path) {
      if (!path) return "/";

      const cleanedPath = path.split("?")[0].replace(/\/+$/, "");

      return cleanedPath || "/";
    },
    isRouteActive(target) {
      if (!target) return false;

      const currentPath = this.currentPath;
      const targetPath = this.normalizePath(target);

      return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
    },
    isGroupActive(item) {
      return Array.isArray(item.children) && item.children.some((children) => this.isRouteActive(children.to));
    },
    toggleMobileDrawer() {
      if (!this.drawerMobile) {
        this.drawerMobile = true;
        return;
      }

      this.requestCloseMobileDrawer();
    },

    requestCloseMobileDrawer() {
      if (this.closing || !this.drawerMobile) return;
      this.closing = true;
      setTimeout(() => {
        this.drawerMobile = false;
        this.closing = false;
      }, 360);
    },
    getMenus() {
      let menus = [];
      this.items.forEach((menu) => {
        if (this.showMenu(menu)) {
          let menuLiberado = {
            title: menu.title,
            icon: menu.icon,
            to: menu.to,
          };

          if (menu.children) {
            menuLiberado.children = [];
            menu.children.forEach((children) => {
              if (this.showMenu(children)) {
                let childrenLiberado = {
                  title: children.title,
                  icon: children.icon,
                  to: children.to,
                };
                menuLiberado.children.push(childrenLiberado);
              }
            });
          }
          menus.push(menuLiberado);
        }
      });
      return menus;
    },
  },
  watch: {
    minivariant(newVal) {
      localStorage.setItem("sidebarOpen", JSON.stringify(!newVal));
      this.isSidebarOpen = !newVal;
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawerMobile = !newVal;
      }
      // Reseta o estado de hover quando muda minivariant
      this.isHovering = false;
    },
  },
  created() {
    const storedSidebar = localStorage.getItem("sidebarOpen");

    if (storedSidebar !== null) {
      this.isSidebarOpen = JSON.parse(storedSidebar);
      this.$store.dispatch("General/setMinivariant", JSON.parse(!this.isSidebarOpen));
    }
    if (this.$root && this.$root.$on) {
      this.$root.$on("toggle-mobile-drawer", this.toggleMobileDrawer);
    }
  },
  beforeDestroy() {
    if (this.$root && this.$root.$off) {
      this.$root.$off("toggle-mobile-drawer", this.toggleMobileDrawer);
    }
  },
};
</script>

<style scoped>
.drawer-owner {
  gap: 8px;
  margin: 16px 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #1f2937;
  font-weight: 700;
  line-height: 1.2;
}

.drawer-logo-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.drawer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 10px;
  flex: 1;
}

.drawer-logo .logo-prefeitura {
  width: 100%;
  max-height: 180px;
  object-fit: contain;
}

.drawer-logo img {
  width: 140px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.close-drawer-btn {
  margin-right: 8px !important;
}

.drawer-owner__text {
  font-size: 1.25rem;
  font-weight: 600;
  color: #334155;
  text-transform: uppercase;
}

.drawer-owner__badge {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: rgba(26, 83, 92, 0.12);
  color: #1a535c;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
}

.menu-item,
.menu-group-activator,
.menu-child-item {
  border-radius: 6px;
  min-height: 32px !important;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.drawer-menu-list::v-deep .v-list-item {
  min-height: 32px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.drawer-menu-list::v-deep .v-list-item__icon {
  margin: 8px 14px 8px 0 !important;
}

.drawer-menu-list::v-deep .v-list-group__header {
  min-height: 32px !important;
}

.drawer-menu-list::v-deep .v-list-group__header .v-list-item {
  min-height: 32px !important;
}

.menu-icon {
  align-self: center !important;
}

.menu-title {
  font-size: 13px !important;
  line-height: 1.25 !important;
  font-weight: 500;
  color: #1e293b !important;
}

.menu-title--child {
  font-size: 12.5px !important;
  font-weight: 400;
  color: #475569 !important;
}

.drawer-menu-list::v-deep .v-list-item__title {
  color: #1e293b !important;
}

.drawer-menu-list::v-deep .v-icon {
  color: #334155 !important;
}

.menu-item--active,
.menu-child-item--active {
  background: rgba(26, 83, 92, 0.12);
  color: #1a535c;
  box-shadow: inset 0 0 0 1px rgba(26, 83, 92, 0.16);
}

.menu-item--active .v-icon {
  color: #1a535c !important;
}

.menu-item--active .menu-title,
.menu-item--active::v-deep .v-list-item__title {
  color: #1a535c !important;
  font-weight: 600;
}

.menu-group {
  width: 100%;
}

.menu-group::v-deep .v-list-group__header {
  width: 100%;
  border-radius: 6px;
}

.menu-group::v-deep .v-list-group__items {
  padding: 2px 0 6px;
  margin: 0 4px 0 12px;
  border-left: 2px solid rgba(26, 83, 92, 0.18);
}

.menu-group::v-deep .v-list-group__items .menu-child-item {
  margin-left: 10px !important;
  margin-right: 4px !important;
  padding-left: 10px !important;
  min-height: 30px !important;
}

.menu-group::v-deep .v-list-group__items .menu-icon--child {
  margin-right: 10px !important;
  min-width: 20px !important;
}

.menu-group::v-deep .v-list-group__items .v-icon {
  color: #64748b !important;
}

.menu-group--active::v-deep .v-list-group__header {
  background: rgba(26, 83, 92, 0.12);
  color: #1a535c;
  box-shadow: inset 0 0 0 1px rgba(26, 83, 92, 0.16);
}

.menu-group--active::v-deep .v-list-group__header .v-icon {
  color: #1a535c !important;
}

.menu-group--active::v-deep .v-list-group__header .v-list-item__title {
  color: #1a535c;
  font-weight: 600;
}

.menu-group--active::v-deep .v-list-group__header .v-list-group__header__append-icon,
.menu-group--active::v-deep .v-list-group__header .v-list-group__header__prepend-icon {
  color: #1a535c !important;
}

.menu-group-activator {
  width: 100%;
}

.drawer-menu-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 75px;
}

.menu-child-item--active {
  background: rgba(26, 83, 92, 0.08);
  color: #0f766e;
  box-shadow: inset 0 0 0 1px rgba(26, 83, 92, 0.12);
}

.menu-child-item--active .v-icon {
  color: #0f766e !important;
}

.menu-child-item--active .menu-title,
.menu-child-item--active::v-deep .v-list-item__title {
  color: #0f766e !important;
  font-weight: 600;
}

.suspended-drawer {
  top: 10px !important;
  left: 10px !important;
  bottom: 10px !important;
  height: auto !important;
  max-height: calc(100% - 20px) !important;
  border-radius: 8px !important;
  box-shadow: 0 0 2px 1px rgba(122, 180, 184, 0.3), 0 4px 8px rgba(82, 126, 129, 0.1) !important;
  overflow: hidden;
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
  z-index: 10 !important;
  transition: transform 300ms cubic-bezier(0.25, 0.8, 0.25, 1), opacity 250ms ease,
    width 300ms cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.suspended-drawer::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.suspended-drawer.v-navigation-drawer--mini-variant .drawer-owner {
  margin: 12px 8px 12px;
  padding: 12px 8px;
  justify-content: center;
  transition: margin 350ms cubic-bezier(0.25, 0.8, 0.25, 1), padding 350ms cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.suspended-drawer.v-navigation-drawer--mini-variant .drawer-owner__text {
  display: none;
}

.drawer-menu-scroll::-webkit-scrollbar {
  width: 6px;
}

.drawer-menu-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.drawer-menu-scroll::-webkit-scrollbar-thumb {
  background: rgba(26, 83, 92, 0.15);
  border-radius: 3px;
  transition: background 0.2s ease;
}

.drawer-menu-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(26, 83, 92, 0.3);
}

.drawer-menu-scroll::-webkit-scrollbar-corner {
  background: transparent;
}

.suspended-drawer.v-navigation-drawer--mini-variant .child-item {
  padding-left: 0 !important;
}

.suspended-drawer--mobile-hidden {
  display: none !important;
}

@media (max-width: 1260px) {
  .suspended-drawer {
    top: 10px !important;
    left: 6px !important;
    right: auto !important;
    bottom: 10px !important;
    width: 40% !important;
    height: calc(100% - 20px) !important;
    max-height: calc(100% - 20px) !important;
    border-radius: 8px !important;
    box-shadow: -2px 0 12px rgba(0, 0, 0, 0.18) !important;
    transition: transform 350ms cubic-bezier(0.25, 0.8, 0.25, 1), opacity 250ms ease;
    transform: translateX(-110%);
    opacity: 0;
    pointer-events: none;
  }

  .suspended-drawer.suspended-drawer--open {
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto;
  }

  .suspended-drawer.closing {
    transform: translateX(-110%);
    opacity: 0;
    pointer-events: none;
  }

  .drawer-menu-scroll {
    margin-bottom: 0;
  }

  .copyright {
    position: relative;
    bottom: auto;
    transform: none;
    left: auto;
  }
}

@media (max-width: 960px) {
  .suspended-drawer {
    width: 75% !important;
  }
}

.copyright {
  font-size: 11px;
  text-align: center;
  bottom: 0px;
  flex: 1;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  width: 90%;
  color: #64748b;
  background-color: #e1f6f7;
}
</style>
